// Auto-generated skeleton for PhoneNumber

import { Person } from "./Person";

export const PhoneNumber: Api.PhoneNumber = {
  id: 0,
  person_id: 0,
  number: '',
  cleaned_number: '',
  description: '',
  notice: null,
  hp_id: null,
  created: null,
  updated: null,
  person: Person,
};

